var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0166AA",
  d: "M.495 4.57 6.66.872a.67.67 0 0 1 .686 0l6.159 3.697a.33.33 0 0 1 .162.286v8.477A.667.667 0 0 1 13 14H1a.666.666 0 0 1-.667-.667V4.855a.33.33 0 0 1 .162-.286m1.172.852v7.245h10.667V5.42l-5.331-3.2zm5.373 3.71 3.53-2.975.86 1.02-4.38 3.691-4.474-3.687.848-1.029z"
})));
export default SvgCheckEnvelope;